// actions
export const CHANGE_CURRENCY = 'CHANGE_CURRENCY';
export const FETCH_EXCHANGE_RATE = 'FETCH_EXCHANGE_RATE';
// mutations
export const SET_NEW_CURRENCY = 'SET_NEW_CURRENCY';
export const SET_EXCHANGE_RATE = 'SET_EXCHANGE_RATE';
